module.exports = __webpack_public_path__ + "img/entry.d02bba22.svg";